import { Controller } from "@hotwired/stimulus"

// Menu burger mobile : ouvre le panneau sous l'en-tête fixe et bloque le défilement.
export default class extends Controller {
  static targets = ["toggle", "panel"]

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.place()
    this.panelTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
    document.documentElement.classList.add("has-menu-open")
  }

  // Le panneau commence au bas de l'en-tête, qui descend sous le bandeau tant qu'on est en haut de page.
  place() {
    const bottom = Math.max(0, this.element.getBoundingClientRect().bottom)
    this.panelTarget.style.setProperty("--menu-top", `${bottom}px`)
  }

  close() {
    if (this.panelTarget.hidden) return
    this.panelTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
    document.documentElement.classList.remove("has-menu-open")
  }
}
